<template>
  <div>
    <v-textarea
      v-model="commentEdit.content"
      hide-details
      label="Write a comment..."
      filled
      rows="1"
      rounded
      auto-grow
    >
      <template slot="append">
        <v-btn
          color="primary"
          text
          :disabled="!commentEdit.content"
          @click="addComment"
        >
          Save
        </v-btn>
      </template>
    </v-textarea>

    <v-timeline
      dense
      class="mt-6 pt-0"
    >
      <v-slide-x-transition group>
        <v-timeline-item
          v-for="comment in comments.models"
          :key="comment.id"
          large
        >
          <pa-user-avatar
            slot="icon"
            :user-id="comment.createdBy"
            type="avatar"
          />

          <div v-if="!comment.isEditing">
            {{ comment.$.content }}
          </div>

          <v-textarea
            v-else
            v-model="comment.content"
            hide-details
            label="Edit comment"
            filled
            rows="1"
            rounded
            auto-grow
          >
            <template slot="append-outer">
              <v-btn
                color="primary"
                text
                :disabled="!comment.content || comment.saving || comment.loading"
                :loading="comment.saving"
                @click="saveComment(comment)"
              >
                Save
              </v-btn>
            </template>
          </v-textarea>

          <p class="grey--text ma-0 text-right">
            <small>{{ comment.createdAt | fmtDate }}</small>
          </p>

          <div
            v-if="comment.createdBy === $currentUser.id"
            class="grey--text ma-0 text-right"
          >
            <v-btn
              small
              text
              :disabled="comment.deleting || comment.saving || comment.loading"
              @click="comment.isEditing = !comment.isEditing"
            >
              {{ comment.isEditing ? 'Cancel' : 'Edit' }}
            </v-btn>

            <v-btn
              color="error"
              small
              text
              :disabled="comment.deleting || comment.saving || comment.loading"
              :loading="comment.deleting"
              @click="deleteComment(comment)"
            >
              Delete
            </v-btn>
          </div>
        </v-timeline-item>
      </v-slide-x-transition>
    </v-timeline>
  </div>
</template>

<script>
import Comment from '@/models/Comment'
import Comments from '@/models/CommentsCollection'

export default {
  props: {
    docRef: {
      type: String,
      default: null
    },
    project: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      comments: new Comments(),
      commentEdit: null
    }
  },
  watch: {
    docRef () {
      this.commentEdit.entityRef = this.docRef
      this.loadComments()
    }
  },
  created () {
    this.commentEdit = new Comment({}, this.comments)
  },
  mounted () {
    this.loadComments()
  },
  methods: {
    async loadComments () {
      if (!this.docRef) { return }

      await this.comments.fetch({
        entityRef: this.docRef
      }, {
        sort: { createdAt: -1 }
      })
    },
    async addComment () {
      this.commentEdit.entityRef = this.docRef
      this.commentEdit.project = this.project
      await this.commentEdit.save()
      this.commentEdit = new Comment({}, this.comments)
    },
    async saveComment (comment) {
      await comment.save()
      comment.isEditing = false
    },
    async deleteComment (comment) {
      await comment.delete()
    }
  }
}
</script>

<style>

</style>
